var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$slots.tooltipTarget
      ? _c("div", { ref: "tooltipTargetRef" }, [_vm._t("tooltipTarget")], 2)
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-none", attrs: { "data-testid": "tooltip-templates" } },
      [
        _vm.$slots.tooltipTarget && _vm.$slots.tooltipContent
          ? _c(
              "div",
              {
                ref: "tooltipContentRef",
                staticClass: "tooltip-content-container",
                on: { click: _vm.onClickInTooltip },
              },
              [
                _vm.withCloseTooltipButton
                  ? _c(
                      "button",
                      {
                        staticClass: "btn-close",
                        attrs: { type: "button", "aria-label": "Fermer" },
                        on: { click: _vm.closeTooltip },
                      },
                      [
                        _c("span", {
                          staticClass: "icon icon-delete",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("tooltipContent"),
              ],
              2
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }